import React, { useState, useEffect } from "react";
import { useLocation } from "@reach/router";
import { ThemeProvider } from "styled-components";
import theme from "../styles/theme";
import GlobalStyle from "../styles/GlobalStyle";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const isHome = location?.pathname === "/";
  const [isLoading, setIsLoading] = useState(isHome);

  useEffect(() => {
    if (isLoading) {
      const timer = setTimeout(() => setIsLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <div id="root">
        <Header isHome={isHome} />
        <main id="content">{children}</main>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Layout;